import { useState } from 'react'
import { Box, Chip, IconButton, Tooltip, Typography } from '@mui/material'
import { ICON_XS } from '../common/theme'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import FancyProgressArc from './FancyProgressArc'
import TraceArc from './TraceArc'

interface TaSourceMatchProps {
  bideval?: any
  answerObj?: any
  onValidate?: () => void
}

export default function TaSourceMatch({ bideval, answerObj }: TaSourceMatchProps) {
  const [showAll, setShowAll] = useState(!!(answerObj?.anyperson || answerObj?.anyorg))
  const isOutOfDate = bideval && answerObj && answerObj.answersha !== bideval.answersha
  const hasDetail = answerObj?.anyperson || answerObj?.anyorg

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
        <TraceArc value={answerObj?.simint ?? 0} />
        {bideval && (
          <Box sx={{ opacity: isOutOfDate ? 0.45 : 1 }}>
            <FancyProgressArc
              value={bideval.scoreint ?? 0}
              zerona
              scale={0.65}
              tooltip={isOutOfDate ? 'Out of Date' : 'Response Evaluation'}
            />
          </Box>
        )}
        
        {hasDetail && (
          <Tooltip title={showAll ? 'Hide citations' : 'Show citations'}>
            <IconButton size="small" onClick={() => setShowAll(v => !v)} sx={{ p: 0.25 }}>
              {showAll ? <ExpandLessIcon sx={{ fontSize: ICON_XS }} /> : <ExpandMoreIcon sx={{ fontSize: ICON_XS }} />}
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {showAll && hasDetail && (
        <Box sx={{ mt: 0.5, pl: 0.75, borderLeft: 2, borderColor: 'divider' }}>
          {answerObj?.anyperson && (
            <Box sx={{ mb: 0.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.25 }}>
                <Typography variant="caption" sx={{ fontSize: '0.68rem', opacity: 0.6 }}>People Citations</Typography>
                <Chip size="small" label="BETA" sx={{ height: 14, fontSize: '0.58rem' }} />
              </Box>
              {answerObj?.entitysimgroups
                ?.filter((vlist: any[]) => vlist[0]?.entitytypestring === 'person')
                .map((vlist: any[], i: number) => (
                  <Typography key={i} variant="caption" sx={{ display: 'block', fontSize: '0.7rem' }}>
                    {vlist[0].entity}
                  </Typography>
                ))}
            </Box>
          )}
          {answerObj?.anyorg && (
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.25 }}>
                <Typography variant="caption" sx={{ fontSize: '0.68rem', opacity: 0.6 }}>Entity Citations</Typography>
                <Chip size="small" label="BETA" sx={{ height: 14, fontSize: '0.58rem' }} />
              </Box>
              {answerObj?.entitysimgroups
                ?.filter((vlist: any[]) => vlist[0]?.entitytypestring === 'org')
                .map((vlist: any[], i: number) => (
                  <Typography key={i} variant="caption" sx={{ display: 'block', fontSize: '0.7rem' }}>
                    {vlist[0].entity}
                  </Typography>
                ))}
            </Box>
          )}
        </Box>
      )}
    </Box>
  )
}
